import React, { useState } from "react";
import {
  Table,
  Tag,
  Space,
  Divider,
  Button,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
} from "antd";
import { toast, ToastContainer } from "react-toastify";
import { UserOutlined, LockOutlined, TeamOutlined } from "@ant-design/icons";
import { Row, Col } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { add_fact_step3 } from "../../Redux/actions";
import axios from "axios";
import { baseUrl } from "../../Controllers/rest_api_config";
import { error, warning, success } from "../../Controllers/toast";
import { gql, useMutation } from "@apollo/client";
const { Option } = Select;

const layout = {
  labelCol: {
    span: 9,
  },
  wrapperCol: {
    span: 15,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 0,
    span: 24,
  },
};

const check_color = (role) => {
  switch (role) {
    case "editor":
      return "purple";
    case "reader":
      return "blue";
    default:
      return "lime";
  }
};
const check_name = (role) => {
  switch (role) {
    case "editor":
      return "ادیتور";
    case "reader":
      return "بیننده";
    default:
      return "عضو";
  }
};

const CHECK_USER = gql`
  mutation CheckUserInput($email: String!, $mobile: String!) {
    CheckUserExist(email: $email, mobile: $mobile) {
      user_id
      firstname
      lastname
      email
      mobile
    }
  }
`;

const Step3_users_list = (props) => {
  const add_fact = useSelector((state) => state.add_fact_step3);
  const dispatch = useDispatch();

  const columns = [
    {
      title: "نام",
      dataIndex: "firstname",
      key: "firstname",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "نام خانوادگی",
      dataIndex: "lastname",
      key: "lastname",
    },

    {
      title: "نقش",
      key: "role",
      dataIndex: "role",
      render: (role, row, index) => {
        let color = check_color(role);
        let name = check_name(role);

        return (
          <Tag color={color} key={index}>
            {name}
          </Tag>
        );
      },
    },
    {
      title: "تغییرات",
      key: "action",
      render: (text, record, index) => {
        return (
          <Space size="middle">
            <a
              onClick={() => {
                Modal.warning({
                  width: "60%",
                  title: "تغییر اطلاعات ",
                  content: (
                    <Modal_Content
                      text="!اطلاعات با موفقیت تغییر یافت"
                      change={true}
                      index={index}
                    />
                  ),
                  okType: "danger",
                  okText: "بازگشت",
                });
              }}
            >
              تغییر نقش
            </a>
            <Divider type="vertical" />
            <a
              onClick={() => {
                Modal.error({
                  title: "حذف کاربر ",
                  content: "آیا از حذف کاربر اطمینان دارید ؟",
                  okType: "danger",
                  okText: "حذف",
                  cancelText: "بازگشت",
                  okCancel: true,
                  onOk() {
                    setData(data.filter((data) => data.email !== record.email));
                    warning("!کاربر با موفقیت حذف شد ");
                  },
                });
              }}
            >
              حذف
            </a>
          </Space>
        );
      },
    },
  ];

  const [data, setData] = useState(add_fact);
  const [role, setRole] = useState();

  const [checkUser, { loading }] = useMutation(CHECK_USER, {
    onCompleted: (res) => {
      // console.log(res);
      if (res.CheckUserExist.user_id !== null) {
        // console.log([...data, { ...res.CheckUserExist, role }]);
        setData([...data, { ...res.CheckUserExist, role }]);
        Modal.destroyAll();
        success("کاربر با موفقیت اضافه شد !");
      } else {
        error("کاربری با این مشخصات یافت نشد!");
      }
    },
    onError: (err) => {
      // console.log(err);
      error("مشکلی رخ داده است!");
    },
  });

  const Modal_Content = ({ text, change, index }) => {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);

    const handleFinish = (value) => {
      let { email, mobile, role } = value;
      mobile = mobile.replace(0, 98);
      setRole(role);
      checkUser({ variables: { email, mobile } });
      form.resetFields();
      // axios
      //   .post(
      //     `${baseUrl}/add_fact/user_exist`,
      //     {},
      //     { params: { email, mobile, role } }
      //   )
      //   .then((res) => {
      //     console.log(res, res.data.result.response.status);
      //     if (res.data.result.response.status === "success") {
      //       console.log([...data, res.data.result.response.user]);
      //       setData([...data, res.data.result.response.user]);
      //       success(text);

      //     } else {
      //       warning("مشکلی رخ داده است!");
      //     }
      //   })
      //   .catch((err) => {
      //     if (err.response) {
      //       error(err.response.data.text);
      //     } else {
      //       warning("مشکلی رخ داده است!");
      //     }
      //   });
    };

    const onFinish = (value) => {
      if (change !== true) {
        if (data.length === 0) {
          // console.log(data, value);

          handleFinish(value);
          //   //   console.log("i am here 1");
          //   setData([value]);
          //   success(text);
        } else {
          // console.log("i am here 2");
          
          const repeatiousUser = data.filter(user => user.email === value.email)
          const repeatiousUser2 = data.filter(user => user.mobile === value.mobile)

          if(repeatiousUser.length>0 || repeatiousUser2.length>0){
            error("! اطلاعات وارد شده تکراری است ");

          }else{
            // console.log(data, value);
            // if(visible === true){
            handleFinish(value);
            // }

          }
        }
      } else {
        data[index].role = value.role;
        setData([...data]);
        warning(text);
        form.resetFields();
        Modal.destroyAll();
      }
    };
    const onFinishFailed = (err) => {
      console.warn(err);
    };
    const toggleCheckBox = (value) => {
      setVisible(value.target.checked);
    };
    if (change !== true) {
      return (
        <Form
          {...layout}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          // initialValues={{ checked: false, contractor: false }}
        >
          {
            <Form.Item
              {...tailLayout}
              name="role"
              key="role"
              label={
                <span>
                  <TeamOutlined className="Icon-style" /> نقش{" "}
                </span>
              }
              rules={[{ required: true, message: "لطفا نقش را وارد کنید !" }]}
            >
              <Select hasFeedback className="login-form-style ">
                <Option value="editor">ادیتور</Option>
                <Option value="reader">بیننده</Option>
              </Select>
            </Form.Item>
          }

          <React.Fragment>
            <Form.Item
              name="email"
              key="email"
              label={
                <span>
                  <TeamOutlined className="Icon-style" /> پست الکترونیکی{" "}
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "لطفا پست الکترونیکی را وارد کنید !",
                },
                {
                  type: "email",
                  message: "لطفا ایمیل خود را به درستی وارد کنید !",
                },
              ]}
            >
              <Input
                className="login-form-style input-ltr"
                style={{ direction: "ltr !important" }}
              />
            </Form.Item>
            <Form.Item
              name="mobile"
              key="mobile"
              label={
                <span>
                  <TeamOutlined className="Icon-style" /> شماره موبایل{" "}
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "لطفا شماره موبایل را وارد کنید !",
                },

                {
                  pattern: /[0-9]\d{8,}/g,
                  message: "لطفا شماره موبایل را به درستی وارد کنید!",
                },
              ]}
            >
              <Input
                className="login-form-style input-ltr"
                style={{ direction: "ltr !important" }}
              />
            </Form.Item>
          </React.Fragment>

          <Form.Item {...tailLayout} className="text-center">
            <Button type="primary" htmlType="submit">
              تایید اطلاعات
            </Button>
          </Form.Item>
        </Form>
      );
    } else {
      return (
        <Form
          {...layout}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ checked: false, contractor: false }}
        >
          <Form.Item
            {...tailLayout}
            name="role"
            key="role"
            label={
              <span>
                <TeamOutlined className="Icon-style" /> نقش{" "}
              </span>
            }
            rules={[{ required: true, message: "لطفا نقش را وارد کنید !" }]}
          >
            <Select hasFeedback className="login-form-style ">
              <Option value="editor">ادیتور</Option>
              <Option value="reader">بیننده</Option>
            
            </Select>
          </Form.Item>
          <Form.Item {...tailLayout} className="text-center">
            <Button type="primary" htmlType="submit">
              تایید اطلاعات
            </Button>
          </Form.Item>
        </Form>
      );
    }
  };

  return (
    <div>
      {/* <ToastContainer /> */}
      <Button
        className="mb-3"
        type="primary"
        onClick={() => {
          Modal.info({
            width: "60%",
            title: "اضافه کردن کاربر",
            content: <Modal_Content text="!کاربر با موفقیت اضافه شد" />,
            okType: "danger",
            okText: "انصراف",
          });
        }}
      >
        ایجاد کاربر
      </Button>
      <Table columns={columns} dataSource={data} />

      <Row className="mt-4">
        <Col className="text-right">
          <Button
            disabled={data.length === 0 ? true : false}
            onClick={() => {
              dispatch(add_fact_step3(data));
              props.validation(true);
              props.data(data, "step3");
            }}
            type="primary"
          >
            مرحله بعدی
          </Button>
        </Col>
        <Col className="text-left">
          <Button
            onClick={() => {
              dispatch(add_fact_step3(data));
              props.back(true);
              props.data(data, "step3");
            }}
            danger
          >
            مرحله قبل
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Step3_users_list;
